import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AvatarComponent } from '@shared/components';
import { ButtonComponent } from '../button/button.component';
import { SettingsService } from '@app/settings.service';
import { NgxMaskPipe } from 'ngx-mask';
import { UtilService } from '@helpers/util.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-card-agent',
  templateUrl: './card-agent.component.html',
  styleUrls: ['./card-agent.component.scss'],
  standalone: true,
  imports: [AvatarComponent, ButtonComponent, CommonModule],
  providers: [NgxMaskPipe],
})
export class CardAgentComponent implements OnInit {
  @Input() agentDto: any;
  @Input() isProfileAgent: boolean;
  @Input() totalObjects = 0;
  @Input() city: any;
  @Output() navigateToObjects = new EventEmitter();

  currentLanguageAsKey = this._settingsService.getCurrentLanguageAsKey();
  textButton = 'Показать телефон';
  isShowPhone = false;
  isMobile = false;

  destroy$: Subject<void> = new Subject<void>();
  constructor(
    private _settingsService: SettingsService,
    private _mask: NgxMaskPipe,
    private _utilService: UtilService,
  ) {}

  ngOnInit(): void {
    this.agentDto.phoneNumber = this.agentDto.phoneNumber || this.agentDto.phone;
    this._settingsService
      .isMobile()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => (this.isMobile = data));
  }

  getAchievementTitle(): string {
    return this.agentDto.agentAchievement?.achievement[this.currentLanguageAsKey];
  }

  public getImageUrl(): string {
    const path = this._utilService.getFilePath();
    return path + this.agentDto.agentAchievement.achievement.photoUuid;
  }

  roundNumber(number: number) {
    return number.toFixed(1);
  }
  changeTextButton() {
    const number = this.city === 'Almaty' ? '7712288822' : '7057559595';
    if (this.isShowPhone) {
      window.open(`tel:+7${number}`);
    }
    this.isShowPhone = !this.isShowPhone;
    this.textButton = this.isShowPhone ? this._mask.transform('7' + number, '+0 000 000 00 00') : 'Показать телефон';
  }
}
